import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function About() {
  const {
    t
  } = useLanguage();
  return <section className="py-32 bg-svt-bg-alt relative overflow-hidden transition-colors duration-300" data-id="element-13">
      <div className="absolute top-0 left-0 w-full h-full bg-grid-pattern opacity-[0.02] pointer-events-none" data-id="element-14"></div>
      <div className="absolute top-1/2 right-0 -translate-y-1/2 w-[500px] h-[500px] bg-svt-purple/10 blur-[120px] rounded-full pointer-events-none" data-id="element-15"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-16">
        <div className="flex flex-col md:flex-row items-center gap-16 max-w-6xl mx-auto" data-id="element-17">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full md:w-1/2 relative" data-id="element-18">
            <div className="relative w-full aspect-square max-w-md mx-auto" data-id="element-19">
              <div className="absolute inset-0 bg-gradient-to-br from-svt-pink/20 to-svt-purple/20 rounded-full blur-3xl animate-pulse" data-id="element-20"></div>
              <div className="absolute inset-8 border border-svt-border rounded-full flex items-center justify-center backdrop-blur-sm bg-svt-surface" data-id="element-21">
                <div className="absolute inset-4 border border-svt-pink/30 rounded-full border-dashed animate-[spin_20s_linear_infinite]" data-id="element-22"></div>
                <div className="w-24 h-24 bg-gradient-primary rounded-full shadow-[0_0_40px_rgba(232,67,147,0.5)] flex items-center justify-center" data-id="element-23">
                  <span className="text-white text-4xl" data-id="element-24">✨</span>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full md:w-1/2" data-id="element-25">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-svt-border bg-svt-surface mb-6" data-id="element-26">
              <span className="text-svt-purple text-xs font-bold tracking-widest uppercase" data-id="element-27">
                {t('about.badge')}
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-8 leading-tight text-svt-text" data-id="element-28">
              {t('about.title')}{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-svt-pink to-svt-purple" data-id="element-29">
                SVT Dating
              </span>
            </h2>
            <div className="relative pl-6 border-l-2 border-svt-pink/30" data-id="element-30">
              <p className="text-svt-text-secondary leading-relaxed text-lg font-light" data-id="element-31">
                {t('about.text1')}
              </p>
              <br data-id="element-32" />
              <p className="text-svt-text-secondary leading-relaxed text-lg font-light" data-id="element-33">
                {t('about.text2')}
              </p>
            </div>
          </motion.div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-svt-purple/30 to-transparent" data-id="element-34"></div>
    </section>;
}